import Api from '../Api';

export const getQualityChecks = query => async dispatch => {
  const { data } = await Api.get('/quality-checks', query);
  dispatch({
    type: 'FETCH_QUALITY_CHECKS',
    payload: data,
  });
};

export const clearQualityChecks = () => {
  return {
    type: 'CLEAR_QUALITY_CHECKS',
  };
};

export const getQualityCheck = id => async dispatch => {
  const { data } = await Api.get(`/quality-checks/${id}`);
  dispatch({
    type: 'FETCH_QUALITY_CHECK',
    payload: data,
  });
};

export const clearQualityCheck = () => {
  return {
    type: 'CLEAR_QUALITY_CHECK',
  };
};

export const getDebitNotes = () => async dispatch => {
  const { data } = await Api.get('/quality-checks/debit-notes');
  dispatch({
    type: 'FETCH_DEBIT_NOTES',
    payload: data,
  });
};

export const clearDebitNotes = () => {
  return {
    type: 'CLEAR_DEBIT_NOTES',
  };
};

export const getQualityCheckView = id => async dispatch => {
  const { data } = await Api.get(`/quality-checks/${id}/view`);
  dispatch({
    type: 'FETCH_QUALITY_CHECK_VIEW',
    payload: data,
  });
};

export const clearQualityCheckView = () => {
  return {
    type: 'CLEAR_QUALITY_CHECK_VIEW',
  };
};

export const setQualityCheckFiles =
  (itemType, itemIndex, file, isRemove = false) =>
  async dispatch =>
    dispatch({
      type: 'SET_QUALITY_CHECK_FILES',
      payload: { itemType, itemIndex, file, isRemove: Boolean(isRemove) },
    });

export const deleteQualityCheckItem = (itemType, itemIndex) => async dispatch =>
  dispatch({
    type: 'DELETE_QUALITY_CHECK_ITEM',
    payload: { itemType, itemIndex },
  });

export const clearQualityCheckFiles = () => {
  return {
    type: 'CLEAR_QUALITY_CHECK_FILES',
  };
};

export const getQCReport = query => async dispatch => {
  const { data } = await Api.get(`/quality-checks/report`, query);

  dispatch({
    type: 'FETCH_QC_REPORT',
    payload: data,
  });
};

export const clearQCReport = () => {
  return {
    type: 'CLEAR_QC_REPORT',
  };
};
